import { SUBMOTIVE4_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useSubmotive4List } from './hook';
import { Submotive4ListProps } from './props';

export const Submotive4List = ({ filters }: Submotive4ListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useSubmotive4List(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(`${SUBMOTIVE4_DETAIL}/${item.id}`, '_blank')
            }
        />
    );
};
